import React, { Component } from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';
import {
  Row,
  Col,
  Button,
  Modal,
  OverlayTrigger,
  Popover,
} from 'react-bootstrap';
import _ from 'underscore';
import CargomaticInput from 'components/v2/input';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { sluggify } from 'utils/localization/utils';
import accessorialMap from '../../../../config/accessorials';
import AccessorialMetaInput from './AccessorialMetaInput';

class AddAccessorialModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      autoComplete: null,
    };
  }

  getAccessorials() {
    const shipment = this.props.shipment || {};
    const accessorials = (shipment.shipper_accessorials || []).filter(
      (a) => a.key !== 'customer_adjustment',
    );
    return accessorials;
  }

  addAccessorial(key, metaKey) {
    return (metaValue, message) => {
      const accessorial = { [metaKey]: parseInt(metaValue, 10) };
      if (message) accessorial.message = message;
      this.props.addAccessorial(this.props.shipment, key, accessorial);
    };
  }

  removeAccessorial(key) {
    return (e) => {
      e.preventDefault();
      this.props.removeAccessorial(this.props.shipment, key);
    };
  }

  renderCurrentAccessorials() {
    const { t } = this.props;
    const accessorials = this.getAccessorials();
    return accessorials.map((accessorial, index) => {
      const systemAccessorial = accessorialMap[accessorial.key];
      if (!systemAccessorial) return;
      return (
        <div style={{ marginBottom: '5px' }} key={index}>
          <button
            style={{ width: 120 }}
            className="button button-green"
            disabled
          >
            <img
              alt=""
              className="icon"
              width="20"
              src={systemAccessorial?.picture_url}
            />
            <div>
              <span>{t(sluggify(accessorial?.description))}</span>
            </div>
          </button>
          <a
            className="px-2"
            href="#"
            onClick={this.removeAccessorial(accessorial.key)}
          >
            {t('REMOVE')}
          </a>
        </div>
      );
    });
  }

  renderAvailableAccessorials() {
    const { autoComplete } = this.state;
    const { t } = this.props;
    const accessorials = this.getAccessorials();

    let availableAccessorials = _.omit(
      accessorialMap,
      _.pluck(accessorials, 'key'),
    );

    if (availableAccessorials && autoComplete) {
      let filteredAccessorials = {};
      _.map(availableAccessorials, (item) => {
        if (
          item.description.toLowerCase().includes(autoComplete.toLowerCase())
        ) {
          filteredAccessorials[item.value] = item;
        }
      });
      availableAccessorials = filteredAccessorials;
    }

    const renderAccessorialButton = (accessorial, key, renderMeta) => {
      if (renderMeta) {
        return (
          <button
            className="button button-green"
            key={key}
            style={{ width: 120 }}
          >
            <img
              alt=""
              className="icon"
              width="20"
              src={accessorial.picture_url}
            />
            <div>
              <span>{t(accessorial.localizeDescription)}</span>
            </div>
          </button>
        );
      }
      return (
        <button
          className="button button-green"
          onClick={this.addAccessorial(key)}
          key={key}
          style={{ width: 120 }}
        >
          <img
            alt=""
            className="icon"
            width="20"
            src={accessorial.picture_url}
          />
          <div>
            <span>{t(accessorial.localizeDescription)}</span>
          </div>
        </button>
      );
    };

    const handleChange = (key) => (value) => {
      const { meta } = this.state;
      this.setState({
        meta: update(meta, {
          $set: Object.assign(meta, {
            [key]: value,
          }),
        }),
      });
    };

    const renderAccessorialInput = (accessorial, key) => {
      const renderMeta = accessorial.meta_data || this.props.requireApproval;
      const { t } = this.props;
      if (renderMeta) {
        const metaKey = Object.keys(accessorial.meta_data)[0];
        const popover = (
          <Popover
            id="add-accessorial-popover"
            className="popover-positioned-right"
            title={t('ADDITIONAL_INFO')}
          >
            <AccessorialMetaInput
              accessorial={accessorial}
              shipment={this.props.shipment}
              requireApproval={this.props.requireApproval}
              addAccessorial={this.addAccessorial(key, metaKey)}
              onChange={handleChange}
              metaKey={metaKey}
            />
          </Popover>
        );
        return (
          <OverlayTrigger
            trigger="click"
            placement="right"
            overlay={popover}
            rootClose
          >
            {renderAccessorialButton(accessorial, key, renderMeta)}
          </OverlayTrigger>
        );
      }
      return renderAccessorialButton(accessorial, key, renderMeta);
    };
    const sortedAccessorialNames = _.sortBy(
      Object.keys(availableAccessorials),
      (name) => name,
    );
    return _.map(sortedAccessorialNames, (accessorial) => (
      <div style={{ marginBottom: '5px' }} key={accessorial}>
        {renderAccessorialInput(
          availableAccessorials[accessorial],
          accessorial,
        )}
      </div>
    ));
  }

  renderAccessorialNotAvailable(error) {
    const { t } = this.props;
    if (error) {
      return (
        <p className="text-warning">{t('NO_ACCESS_TO_THIS_ACCESSORIAL')}</p>
      );
    }
    return null;
  }

  render500WeightWarning() {
    const accessorials = this.getAccessorials();
    const { t } = this.props;
    if (_.where(accessorials, { key: 'over_500_weight' }).length !== 0) {
      return (
        <p className="text-warning">
          {t('ADDED_OVER_500_ACCESSORIAL_CONFIRM')}
        </p>
      );
    }
    return null;
  }

  renderWhiteGloveWarning() {
    const accessorials = this.getAccessorials();
    const { t } = this.props;
    if (_.where(accessorials, { key: 'white_glove' }).length !== 0) {
      return (
        <p className="text-warning">
          {t('ADDED_WHITE_GLOVE_ACCESSORIAL_SHIPPER_APPROVAL')}
        </p>
      );
    }
    return null;
  }

  renderBody() {
    const { autoComplete } = this.state;
    const { t } = this.props;
    return (
      <div>
        <Row>
          <Col xs={12}>
            <CargomaticInput
              className="mb-4"
              value={autoComplete}
              label={t('ACCESSORIAL_SEARCH')}
              info={t('SEARCH_FOR_AVAILABLE_ACCESSORIALS')}
              onChange={(value) => this.setState({ autoComplete: value })}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <p className="lead">{t('AVAILABLE_ACCESSORIALS')}</p>
            {this.renderAccessorialNotAvailable(this.props.accessorialError)}
            {this.renderAvailableAccessorials()}
          </Col>
          <Col xs={6}>
            <p className="lead">{t('CURRENT_ACCESSORIALS')}</p>
            {this.renderWhiteGloveWarning()}
            {this.render500WeightWarning()}
            {this.renderCurrentAccessorials()}
          </Col>
        </Row>
      </div>
    );
  }

  render() {
    const body = this.props.show ? this.renderBody() : null;
    const { t } = this.props;
    return (
      <Modal
        show={this.props.show}
        onHide={this.props.onHide}
        enforceFocus={false}
      >
        {' '}
        {/* enforceFocus={false} is needed here to not break the inputs */}
        <Modal.Body>{body}</Modal.Body>
        <Modal.Footer>
          <Button onClick={this.props.onHide}>{titleize(t('CLOSE'))}</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

AddAccessorialModal.defaultProps = {
  requireApproval: false,
  shipment: {
    shipper_accessorials: [],
  },
};

AddAccessorialModal.propTypes = {
  addAccessorial: PropTypes.func.isRequired,
  removeAccessorial: PropTypes.func.isRequired,
  requireApproval: PropTypes.bool,
  shipment: PropTypes.shape({
    shipper_accessorials: PropTypes.array,
  }),
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  load: PropTypes.shape({
    pallets: PropTypes.arrayOf(
      PropTypes.shape({
        quantity: PropTypes.number,
      }),
    ),
    weight: PropTypes.number,
  }),
};

export default withTranslation()(AddAccessorialModal);
